import MatchType from "./MatchType";

export default class FootballStatus {
    static ERROR = 0
    static NOT_START = 1
    static FIRST_HALF = 2
    static MIDFIELD = 3
    static SECOND_HALF = 4
    static OVERTIME = 5
    static OVERTIME_1 = 6
    static PENALTY_KICK = 7
    static FINISH = 8
    static PUT_OFF = 9
    static INTERRUPT = 10
    static WAIST_CUT = 11
    static CANCELED = 12
    static DETERMINED = 13

    static getStatus(status) {
        switch (status) {
            case FootballStatus.ERROR:
                return '比赛异常';
            case FootballStatus.NOT_START:
                return '未开赛';
            case FootballStatus.FIRST_HALF:
                return '直播中';
            case FootballStatus.MIDFIELD:
                return '直播中';
            case FootballStatus.SECOND_HALF:
                return '直播中';
            case FootballStatus.OVERTIME:
                return '加时赛';
            case FootballStatus.OVERTIME_1:
                return '加时赛';
            case FootballStatus.PENALTY_KICK:
                return '点球决战';
            case FootballStatus.FINISH:
                return '完场';
            case FootballStatus.PUT_OFF:
                return '推迟';
            case FootballStatus.INTERRUPT:
                return '中断';
            case FootballStatus.WAIST_CUT:
                return '腰斩';
            case FootballStatus.CANCELED:
                return '取消';
            case FootballStatus.DETERMINED:
                return '待定';
        }
        return '';
    }
}
